export const fallbackLng = 'tr';
export const languages = [fallbackLng, 'en'];
export const defaultNS = 'main';

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}
